function showConfirmation(message, confirmedAction, canceledAction, warning, warningTitle, confirmModalTitle, confirmButtonText, cancelButtonText) {
    return showConfirmationObj({
        message: message,
        confirmedAction: confirmedAction,
        canceledAction: canceledAction,
        warning: warning,
        warningTitle: warningTitle,
        confirmModalTitle: confirmModalTitle,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText
    });
}

function showConfirmationObj(settings) {
    var defaults = {
        message: "Are you sure?",
        confirmedAction: null,
        canceledAction: null,
        warning: null,
        warningTitle: null,
        confirmModalTitle: "Are You Sure?",
        confirmButtonText: "Yes, I'm Sure",
        cancelButtonText: "No, Cancel"
    };

    settings = $.extend(defaults, settings);

    $('#confirmModal #confirmMessage').html(settings.message);

    if (settings.warning) {
        $('#confirmModal #confirmWarning').removeClass('hidden');
        $('#confirmModal #confirmWarningMessage').html(settings.warning);

        if (settings.warningTitle) {
            $('#confirmModal #confirmWarningTitle').html(settings.warningTitle);
        }
        else {
            $('#confirmModal #confirmWarningTitle').html('');
        }
    }
    else {
        $('#confirmModal #confirmWarning').addClass('hidden');
        $('#confirmModal #confirmWarningTitle').html('');
        $('#confirmModal #confirmWarningMessage').html('');
    }

    $('#confirmModal #confirmSaveChangesButton').unbind();

    $('#confirmModal #confirmSaveChangesButton').click(function () {
        $('#confirmModal').unbind('hidden.bs.modal');
        $('#confirmModal').modal('hide');
        if (settings.confirmedAction) {
            settings.confirmedAction();
        }
    });

    $('#confirmModal #cancelSaveChangesButton').unbind();

    $('#confirmModal #cancelSaveChangesButton').click(function () {
        $('.saveButton').removeClass('disabled').prop('disabled', false);
        $('#confirmModal').modal('hide'); //Hide calls canceledAction
    });

    $('#confirmModal').on('hidden.bs.modal', function (e) {
        if (settings.canceledAction) {
            settings.canceledAction();
        }
    });

    $('#confirmModal #confirmModalTitle').text(settings.confirmModalTitle);
    $('#confirmModal #confirmSaveChangesButton').text(settings.confirmButtonText);

    if (settings.cancelButtonText) {
        $('#confirmModal #cancelSaveChangesButton').removeClass('hidden').text(settings.cancelButtonText);
    }
    else {
        $('#confirmModal #cancelSaveChangesButton').addClass('hidden');
    }

    $('#confirmModal').modal('show');
}